import axios from 'axios';

import { apiGatewayUrl } from '../../config/environment';

export const verifyUserSession = async (): Promise<void> => {
  await axios.get(`${apiGatewayUrl}/verify-session`);
};
